<template>
    <li class="no-padding no-margin w-100 h-100 d-flex align-items-center justify-content-center">
        <div class="h-100 align-items-center p-header d-none d-md-inline-flex">
            <template v-if="useModalFlow === true">
                <span
                    class="pr-4 font-weight-bold text-dark cursor-pointer"
                    data-user-button-login
                    @click.stop.prevent="clickLoginButton"
                >
                    <i class="fa fa-sign-in"></i> {{ textLoginButton }}
                </span>
            </template>
            <template v-else>
                <a
                    class="pr-4 font-weight-bold text-dark"
                    id="login-btn"
                    data-user-button-login
                    :href="linkLoginButton"
                >
                    <i class="fa fa-sign-in"></i> {{ textLoginButton }}
                </a>
            </template>
        </div>

        <div class="h-100 align-items-center p-header-2 d-none d-md-inline-flex">
            <template v-if="useModalFlow === true">
                <span
                    class="btn font-weight-bold btn-signup btn-lg w-auto py-2"
                    data-user-button-register
                    @click.stop.prevent="clickSignupButton"
                >
                    {{ textSignupButton }}
                </span>
            </template>
            <template v-else>
                <a
                    class="btn font-weight-bold btn-signup btn-lg w-auto py-2"
                    data-user-button-register
                    :id="idSignupButton"
                    :href="linkSignupButton"
                >
                    {{ textSignupButton }}
                </a>
            </template>
        </div>

        <a
            class="dropdown-toggle w-100 no-sm-border no-sm-border border-right nav-link bg-white d-xs-flex align-items-center h-100 d-flex d-sm-flex d-md-none d-lg-none pr-2 pr-sm-0"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            href="#"
        >
            <i class="fa fa-bars pr-2 fg-normal"></i>
            <span class="hidden-mobile text-normal">{{ 'Menu' | trans }}</span>
        </a>

        <div
            style="margin-top: -2px"
            class="pt-3 pb-3 pr-3 pl-3 dropdown-menu main-user-dropdown dropdown-menu-right dropdown-menu-hover w-100 border bg-white"
        >
            <div class="h-100 align-items-center">
                <template v-if="useModalFlow === true">
                    <span
                        class="pr-4 font-weight-bold text-dark btn btn-block btn-light"
                        @click.stop.prevent="clickLoginButton"
                        >{{ textLoginButton }}</span
                    >
                </template>
                <template v-else>
                    <a class="pr-4 font-weight-bold text-dark btn btn-block btn-light" :href="linkLoginButton">{{
                        textLoginButton
                    }}</a>
                </template>
            </div>

            <div class="h-100 align-items-center">
                <template v-if="useModalFlow === true">
                    <span
                        class="btn font-weight-bold bg-success text-white btn-block"
                        @click.stop.prevent="clickSignupButton"
                        >{{ textSignupButton }}</span
                    >
                </template>
                <template v-else>
                    <a
                        class="btn font-weight-bold bg-success text-white btn-block fg-white"
                        :id="idSignupButton"
                        :href="linkSignupButton"
                    >
                        {{ textSignupButton }}
                    </a>
                </template>
            </div>
        </div>
    </li>
</template>

<script>
import { translate } from '../../../../qaamgo/helper/translate';
import TransFilter from '../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { satGlobals } from '../../../../qaamgo/sat/helper/sat-globals';
import { translatePath } from '../../../../qaamgo/sat/helper/translate-path';
import { registerPaymentModalHelper } from '../../modal/register_payment_flow/register-payment-modal-helper';
import { pageStoreMixin } from '../../../store/page-store';

export default {
    name: 'UserButtonsAnonymousView',
    props: {
        useModalFlow: {
            type: Boolean,
            default: false,
        },
        enableFreeTrial: {
            type: Boolean,
            default: false,
        },
        links: {
            type: Object,
            default: {},
        },
    },
    mixins: [TransFilter, pageStoreMixin],
    computed: {
        textLoginButton() {
            return translate('Log In');
        },
        textSignupButton() {
            if (this.enableFreeTrial) {
                return translate('Free Trial');
            }

            return translate('Sign Up');
        },
        idSignupButton() {
            if (this.enableFreeTrial) {
                return 'free-trial-btn';
            }

            return 'signup-btn';
        },
        linkSignupButton() {
            let registerLink = this.links?.register ?? satGlobals.getMainUrl() + translatePath('/register');

            // if (this.enableFreeTrial) {
            //   return registerLink;
            // }

            return registerLink;
        },
        linkLoginButton() {
            let loginLink = this.links?.login ?? satGlobals.getMainUrl() + translatePath('/login');

            // if (this.enableFreeTrial) {
            //   return loginLink;
            // }

            return loginLink;
        },
    },
    methods: {
        clickLoginButton() {
            this.store.userPaymentModal.setSkipPayment(true);
            registerPaymentModalHelper.openLogin();
        },
        clickSignupButton() {
            this.store.userPaymentModal.setSkipPayment(true);
            registerPaymentModalHelper.openRegister();
        },
    },
};
</script>
